(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('.header-wrapper .header');
    if (!header) return;

    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateHeader() {
      if (
        document.body.classList.contains('overlay-open') ||
        document.body.classList.contains('mega-menu-open') ||
        document.body.classList.contains('cart-drawer-open')
      ) {
        ticking = false;
        return;
      }

      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down & past threshold - hide header
        header.classList.add('header-hidden');
      } else {
        // Scrolling up - show header
        header.classList.remove('header-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-contact-form"] && !Shopify.designMode) return;
  try {
    
  const form = document.getElementById('InfoContactForm');

  if (form) {
    const successEl = document.getElementById('InfoContactForm-success');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');

      if (submitBtn) submitBtn.disabled = true;

      fetch('/apps/barebells-contact', { method: 'POST', body: formData }).catch(() => {});

      try {
        const response = await fetch('/contact', { method: 'POST', body: formData });

        if (response.ok && successEl) {
          form.style.display = 'none';
          successEl.style.display = 'flex';
          successEl.focus();
        }
      } catch {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
